import { render } from "./NestedForm.vue?vue&type=template&id=646a6d2c&lang=pug"
import script from "./NestedForm.vue?vue&type=script&lang=js"
export * from "./NestedForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__